export type ValidationErrors = { [key: string]: string };

export const validateRequiredFields = (
  fields: { [key: string]: string },
  requiredFields: string[],
  messages: { [key: string]: string }
): ValidationErrors => {
  const errors: ValidationErrors = {};

  requiredFields.forEach((field) => {
    if (!fields[field]) {
      errors[field] = messages[field];
    }
  });

  return errors;
};

export const isAlphanumeric = (value: string): boolean => {
  return /^[a-zA-Z0-9]+$/.test(value);
};

export const isValidateEmail = (value: string): boolean => {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const isExactPasswordFormat = (value: string): boolean => {
  const hasUpperCase: boolean = /[A-Z]/.test(value);
  const hasLowerCase: boolean = /[a-z]/.test(value);
  const hasNumber: boolean = /\d/.test(value);
  const hasSpecialChar: boolean = /[!@#$%^&*(),.?":{}|<>'+\-/;=[\]\\_`~]/.test(
    value
  );
  return hasUpperCase && hasLowerCase && hasNumber && hasSpecialChar;
};

export const isValidMobilePhoneNumberPrefix = (
  phoneNumber: string
): boolean => {
  const mobilePhonePrefixPattern = /^(090|080|070|060)/;
  return mobilePhonePrefixPattern.test(phoneNumber);
};

export const isValidPhoneNumberWithHyphen = (phoneNumber: string): boolean => {
  const phoneNumberPattern = /^\d{2,4}-\d{2,4}-\d{3,4}$/;
  return phoneNumberPattern.test(phoneNumber);
};

export const isNumeric = (value: string): boolean => {
  return /^\d+$/.test(value);
};

export const isValidPostalCodeWithHyphen = (value: string): boolean => {
  const postalCodePattern = /^\d{3}-\d{4}$/;
  return postalCodePattern.test(value);
};

export const isHiragana = (value: string): boolean => {
  const hiraganaPattern = /^[\u3040-\u309Fー]+$/;
  return hiraganaPattern.test(value);
};

export const isMaxLength = (value: string, maxLength: number): boolean => {
  return value.length <= maxLength;
};

export const isWithinRange = (
  value: string,
  min: number,
  max: number
): boolean => {
  const length = value.length;
  return length >= min && length <= max;
};

export const isAlphaUnderscoreHyphen = (value: string): boolean => {
  return /^[a-zA-Z0-9_-]+$/.test(value);
};

export const isAlphaSpecialChar = (value: string): boolean => {
  return /^[a-zA-Z0-9!@#$%^&*(),.?":{}|<>'+\-/;=[\]\\_`~]+$/.test(value);
};
